exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ICbMMZpME47rN57ZKGVqn {\n    color: #67666e !important;\n    background-color: #ebedf2;\n    border-color: #ebedf2;\n}\n\n._1ICbMMZpME47rN57ZKGVqn:hover {\n\n    color: #fff !important;\n    background-color: #f4516c;\n    border-color: #f4516c;\n}", ""]);

// exports
exports.locals = {
	"button": "_1ICbMMZpME47rN57ZKGVqn"
};